import { render, staticRenderFns } from "./cardProductoHome.vue?vue&type=template&id=449120b0&scoped=true&"
import script from "./cardProductoHome.vue?vue&type=script&lang=js&"
export * from "./cardProductoHome.vue?vue&type=script&lang=js&"
import style0 from "./cardProductoHome.vue?vue&type=style&index=0&id=449120b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449120b0",
  null
  
)

export default component.exports